import { useEffect, useRef } from "react";
import { supabase } from "@/lib/supabase";

const EDGE_FUNCTION_URL = `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/sports-rss-fetcher`;

export function useRssAutoFetcher() {
  const lastCheckRef = useRef<number>(0);

  useEffect(() => {
    const now = Date.now();
    // Only check once every 5 minutes in the frontend to avoid excessive calls
    if (now - lastCheckRef.current < 5 * 60 * 1000) return;
    lastCheckRef.current = now;

    let cancelled = false;

    async function trigger() {
      try {
        // Fire and forget - the edge function handles dedup internally
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        fetch(EDGE_FUNCTION_URL, {
          method: "GET",
          signal: controller.signal,
        }).catch(() => {});

        clearTimeout(timeoutId);
      } catch {
        // Silently fail - this is a background task
      }

      // No cleanup needed, it's fire-and-forget
    }

    trigger();
    return () => { cancelled = true; };
  }, []);
}